// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.memberloginbannertext {
  position: absolute;
  left: 3%;
  top: 5%;
}

/**
* General variables
*/
/**
* General configs
*/
button {
  background-color: transparent;
  padding: 0;
  border: 0;
  outline: 0;
  cursor: pointer;
}

input {
  background-color: transparent;
  padding: 0;
  border: 0;
  outline: 0;
}
input[type=submit] {
  cursor: pointer;
}
input::placeholder {
  font-size: 0.85rem;
  letter-spacing: 0.1rem;
  color: #ccc;
}

/**
* Bounce to the left side
*/
@keyframes bounceLeft {
  0% {
    transform: translate3d(100%, -50%, 0);
  }
  50% {
    transform: translate3d(-30px, -50%, 0);
  }
  100% {
    transform: translate3d(0, -50%, 0);
  }
}
/**
* Bounce to the left side
*/
@keyframes bounceRight {
  0% {
    transform: translate3d(0, -50%, 0);
  }
  50% {
    transform: translate3d(calc(100% + 30px), -50%, 0);
  }
  100% {
    transform: translate3d(100%, -50%, 0);
  }
}
/**
* Show Sign Up form
*/
@keyframes showSignUp {
  100% {
    opacity: 1;
    visibility: visible;
    transform: translate3d(0, 0, 0);
  }
}
/**
* Page background
*/
.user {
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
  background-size: cover;
}
.user_options-container {
  position: relative;
}
.user_options-text {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: rgba(34, 34, 34, 0.85);
  border-radius: 3px;
}

@media (max-width: 1300px) {
  .user {
    position: relative;
    top: auto;
    left: auto;
    transform: none;
    margin: 0 auto;
    min-height: 40vh;
  }
}
.user_options-registered,
.user_options-unregistered {
  width: 50%;
  padding: 75px 45px;
  color: #fff;
  font-weight: 300;
}
.user_options-registered_title,
.user_options-unregistered_title {
  margin-bottom: 15px;
  font-size: 1.66rem;
  line-height: 1em;
}
.user_options-registered_text,
.user_options-unregistered_text {
  font-size: 0.83rem;
  line-height: 1.4em;
}
.user_options-registered_login, .user_options-registered_signup,
.user_options-unregistered_login,
.user_options-unregistered_signup {
  margin-top: 30px;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 10px 30px;
  color: #fff;
  text-transform: uppercase;
  line-height: 1em;
  letter-spacing: 0.2rem;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
}
.user_options-registered_login:hover, .user_options-registered_signup:hover,
.user_options-unregistered_login:hover,
.user_options-unregistered_signup:hover {
  color: rgba(34, 34, 34, 0.85);
  background-color: #ccc;
}

/**
* Login and signup forms
*/
.user_options-forms {
  position: absolute;
  top: 50%;
  left: 30px;
  width: calc(50% - 30px);
  min-height: 450px;
  background-color: #fff;
  border-radius: 3px;
  box-shadow: 2px 0 15px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  transform: translate3d(100%, -50%, 0);
  transition: transform 0.4s ease-in-out;
}
.user_options-forms .user_forms-login {
  transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out;
}
.user_options-forms .forms_title {
  margin-bottom: 45px;
  font-size: 1.5rem;
  font-weight: 500;
  line-height: 1em;
  text-transform: uppercase;
  color: var(--primary_color);
  letter-spacing: 0.1rem;
}
.user_options-forms .forms_field:not(:last-of-type) {
  margin-bottom: 20px;
}
.user_options-forms .forms_field-input {
  width: 100%;
  border-bottom: 1px solid #ccc;
  padding: 6px 20px 6px 6px;
  font-family: "Montserrat", sans-serif;
  font-size: 1rem;
  font-weight: 300;
  color: gray;
  letter-spacing: 0.1rem;
  transition: border-color 0.2s ease-in-out;
}
.user_options-forms .forms_field-input:focus {
  border-color: gray;
}
.user_options-forms .forms_buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 35px;
}
.user_options-forms .forms_buttons-forgot {
  font-family: "Montserrat", sans-serif;
  letter-spacing: 0.1rem;
  color: #ccc;
  text-decoration: underline;
  transition: color 0.2s ease-in-out;
}
.user_options-forms .forms_buttons-forgot:hover {
  color: #b3b3b3;
}
.user_options-forms .forms_buttons-action {
  background-color: var(--primary_color);
  border-radius: 3px;
  padding: 10px 35px;
  font-size: 1rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 300;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.1rem;
  transition: background-color 0.2s ease-in-out;
}
.user_options-forms .forms_buttons-action:hover {
  background-color: black;
}
.user_options-forms .user_forms-signup,
.user_options-forms .user_forms-login {
  position: absolute;
  top: 70px;
  left: 40px;
  width: calc(100% - 80px);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out, transform 0.5s ease-in-out;
}
.user_options-forms .user_forms-signup {
  transform: translate3d(120px, 0, 0);
}
.user_options-forms .user_forms-signup .forms_buttons {
  justify-content: flex-end;
}
.user_options-forms .user_forms-login {
  transform: translate3d(0, 0, 0);
  opacity: 1;
  visibility: visible;
}

/**
* Triggers
*/
.user_options-forms.bounceLeft {
  animation: bounceLeft 1s forwards;
}
.user_options-forms.bounceLeft .user_forms-signup {
  animation: showSignUp 1s forwards;
}
.user_options-forms.bounceLeft .user_forms-login {
  opacity: 0;
  visibility: hidden;
  transform: translate3d(-120px, 0, 0);
}
.user_options-forms.bounceRight {
  animation: bounceRight 1s forwards;
}

.user_registered-login,
.user_unregistered-signup {
  margin-top: 30px;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 10px 30px;
  color: #fff;
  text-transform: uppercase;
  line-height: 1em;
  letter-spacing: 0.2rem;
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out;
}
.user_registered-login:hover,
.user_unregistered-signup:hover {
  color: rgba(34, 34, 34, 0.85);
  background-color: #ccc;
}

/**
* Responsive 990px
*/
@media screen and (max-width: 990px) {
  .user_options-forms {
    min-height: 350px;
  }
  .user_options-forms .forms_buttons {
    flex-direction: column;
  }
  .user_options-forms .forms_buttons-action {
    margin-top: 30px;
  }
  .user_options-forms .user_forms-signup,
  .user_options-forms .user_forms-login {
    top: 40px;
  }
  .user_options-registered,
  .user_options-unregistered {
    padding: 50px 45px;
  }
}
/* --- 修正 .user 置中：你原本 translate(50%, -50%) 會把內容推到畫面外 --- */
.user {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%); /* ← 這才是水平垂直置中 */
  max-width: 1100px; /* 防止超寬 */
  width: min(95vw, 1100px);
}

/* --- 讓「雙欄文字 + 浮動表單」在桌機正常 --- */
.user_options-container {
  position: relative;
}

.user_options-text {
  display: flex;
  justify-content: space-between;
  gap: 0; /* 與你的浮動表單搭配，避免出現縫隙 */
}

/* --- 表單面板維持你的動畫邏輯（桌機） --- */
.user_options-forms {
  /* 你原本的定位就好，保留動畫 */
}

/* ====== RWD：<= 990px 手機／小平板：改直排、不動畫、好閱讀 ====== */
@media (max-width: 990px) {
  /* 1) 登入區塊脫離 banner 絕對定位，回到一般文流 */
  .user {
    position: relative !important;
    top: auto !important;
    left: auto !important;
    transform: none !important;
    width: 100% !important;
    max-width: 720px;
    margin: 0 auto;
    padding: 16px;
  }
  /* 2) 左右兩塊文字改成上下直排 */
  .user_options-text {
    flex-direction: column;
    background: rgba(34, 34, 34, 0.85);
    border-radius: 4px;
  }
  .user_options-registered,
  .user_options-unregistered {
    width: 100% !important;
    padding: 32px 20px;
    text-align: center;
  }
  /* 3) 浮動的表單改為「一般區塊」，撐滿寬度，禁用動畫 */
  .user_options-forms {
    position: static !important;
    width: 100% !important;
    min-height: auto !important;
    box-shadow: none !important;
    transform: none !important;
    animation: none !important;
    margin-top: 16px;
    border-radius: 4px;
  }
  .user_options-forms.bounceLeft,
  .user_options-forms.bounceRight {
    animation: none !important;
  }
  /* 4) 內部兩個面板用 React 控（你本來就用 state 二選一），這裡統一可見樣式 */
  .user_options-forms .user_forms-login,
  .user_options-forms .user_forms-signup {
    position: static !important;
    opacity: 1 !important;
    visibility: visible !important;
    transform: none !important;
    width: 100% !important;
    left: auto !important;
    top: auto !important;
    padding: 24px 16px;
  }
  /* 5) 表單字級與間距微調，手機更易讀 */
  .user_options-forms .forms_title {
    font-size: 1.25rem !important;
    margin-bottom: 16px !important;
  }
  .user_options-forms .forms_field:not(:last-of-type) {
    margin-bottom: 14px !important;
  }
  .user_options-forms .forms_buttons {
    margin-top: 20px !important;
    flex-direction: column;
    gap: 12px;
  }
}
/* 手機：讓 .user_options-forms 在上面，.user_options-text 在下面 */
@media (max-width: 990px) {
  .user_options-container {
    display: flex;
    flex-direction: column;
  }
  .user_options-forms {
    order: -1; /* ← 表單排第一（上層） */
    margin-bottom: 16px; /* 與下方說明區留點距離 */
  }
  .user_options-text {
    order: 0;
  }
}
/* 桌機保險一層：確保浮動表單覆蓋在文字之上（維持你原本的上層效果） */
.user_options-forms {
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./src/pages/member/styles/memberlogin.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,kBAAA;EACA,QAAA;EACA,OAAA;AAEJ;;AAAA;;CAAA;AAiBA;;CAAA;AAGA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AAXA;;AAcA;EACA,6BAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;AAXA;AAaA;EACI,eAAA;AAXJ;AAcA;EACI,kBAAA;EACA,sBAAA;EACA,WAlCG;AAsBP;;AAgBA;;CAAA;AAGA;EACA;IACI,qCAAA;EAbF;EAgBF;IACI,sCAAA;EAdF;EAiBF;IACI,kCAAA;EAfF;AACF;AAkBA;;CAAA;AAGA;EACA;IACI,kCAAA;EAhBF;EAmBF;IACI,kDAAA;EAjBF;EAoBF;IACI,qCAAA;EAlBF;AACF;AAuBA;;CAAA;AAGA;EACA;IACI,UAAA;IACA,mBAAA;IACA,+BAAA;EArBF;AACF;AAuBA;;CAAA;AAGA;EACI,kBAAA;EACA,QAAA;EACA,+BAAA;EACA,sBAAA;AArBJ;AAuBI;EACA,kBAAA;AArBJ;AAwBI;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,wCApGU;EAqGV,kBA1GI;AAoFR;;AA0BA;EACI;IACE,kBAAA;IACA,SAAA;IACA,UAAA;IACA,eAAA;IACA,cAAA;IACA,gBAAA;EAvBJ;AACF;AA4BA;;EAEI,UAAA;EACA,kBAAA;EACA,WA7HI;EA8HJ,gBAvHO;AA6FX;AA4BI;;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAzBJ;AA4BI;;EACA,kBAAA;EACA,kBAAA;AAzBJ;AA4BI;;;EAEA,gBAAA;EACA,sBAAA;EACA,kBAjJI;EAkJJ,kBAAA;EACA,WAjJI;EAkJJ,yBAAA;EACA,gBAAA;EACA,sBAAA;EACA,qEAAA;AAzBJ;AA2BI;;;EACI,6BArJM;EAsJN,sBAvJD;AAgIP;;AA4BA;;CAAA;AAGA;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,uBAAA;EACA,iBAAA;EACA,sBAvKI;EAwKJ,kBA1KI;EA2KJ,0CAAA;EACA,gBAAA;EACA,qCAAA;EACA,sCAAA;AAzBJ;AA2BI;EACA,iEAAA;AAzBJ;AA6BI;EACI,mBAAA;EACA,iBAAA;EACA,gBA7KI;EA8KJ,gBAAA;EACA,yBAAA;EACA,2BAAA;EACA,sBAAA;AA3BR;AA+BQ;EACA,mBAAA;AA7BR;AAiCI;EACI,WAAA;EACA,6BAAA;EACA,yBAAA;EACA,qCAlMH;EAmMG,eAAA;EACA,gBAlMG;EAmMH,WAAA;EACA,sBAAA;EACA,yCAAA;AA/BR;AAiCQ;EACA,kBAAA;AA/BR;AAmCI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAjCR;AAmCQ;EACA,qCArNH;EAsNG,sBAAA;EACA,WA1ND;EA2NC,0BAAA;EACA,kCAAA;AAjCR;AAmCQ;EACI,cAAA;AAjCZ;AAqCQ;EACA,sCAAA;EACA,kBAzOA;EA0OA,kBAAA;EACA,eAAA;EACA,qCArOH;EAsOG,gBApOG;EAqOH,WA5OA;EA6OA,yBAAA;EACA,sBAAA;EACA,6CAAA;AAnCR;AAqCQ;EACI,uBAAA;AAnCZ;AAyCI;;EAEA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,wBAAA;EACA,UAAA;EACA,kBAAA;EACA,6FAAA;AAvCJ;AA0CI;EACA,mCAAA;AAxCJ;AA0CI;EACI,yBAAA;AAxCR;AA4CI;EACA,+BAAA;EACA,UAAA;EACA,mBAAA;AA1CJ;;AA8CA;;CAAA;AAII;EACA,iCAAA;AA5CJ;AA8CI;EACI,iCAAA;AA5CR;AA+CI;EACI,UAAA;EACA,kBAAA;EACA,oCAAA;AA7CR;AAiDI;EACA,kCAAA;AA/CJ;;AAmDA;;EAEI,gBAAA;EACA,sBAAA;EACA,kBA/SI;EAgTJ,kBAAA;EAEA,WAhTI;EAiTJ,yBAAA;EACA,gBAAA;EACA,sBAAA;EAEA,qEAAA;AAlDJ;AAoDI;;EACI,6BArTM;EAsTN,sBAvTD;AAsQP;;AAsDA;;CAAA;AAGA;EACI;IACA,iBAAA;EAnDF;EAqDE;IACI,sBAAA;EAnDN;EAqDM;IACA,gBAAA;EAnDN;EAuDE;;IAEI,SAAA;EArDN;EAyDE;;IAEA,kBAAA;EAvDF;AACF;AA0DA,2DAAA;AACA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA,EAAA,gBAAA;EACA,iBAAA,EAAA,SAAA;EACA,wBAAA;AAxDJ;;AA2DE,gCAAA;AACA;EACE,kBAAA;AAxDJ;;AA2DE;EACE,aAAA;EACA,8BAAA;EACA,MAAA,EAAA,qBAAA;AAxDJ;;AA2DE,6BAAA;AACA;EACE,kBAAA;AAxDJ;;AA2DE,kDAAA;AACA;EAEE,iCAAA;EACA;IACE,6BAAA;IACA,oBAAA;IACA,qBAAA;IACA,0BAAA;IACA,sBAAA;IACA,gBAAA;IACA,cAAA;IACA,aAAA;EAzDJ;EA4DE,oBAAA;EACA;IACE,sBAAA;IACA,kCAAA;IACA,kBAAA;EA1DJ;EA4DE;;IAEE,sBAAA;IACA,kBAAA;IACA,kBAAA;EA1DJ;EA6DE,+BAAA;EACA;IACE,2BAAA;IACA,sBAAA;IACA,2BAAA;IACA,2BAAA;IACA,0BAAA;IACA,0BAAA;IACA,gBAAA;IACA,kBAAA;EA3DJ;EA6DE;;IACkC,0BAAA;EA1DpC;EA4DE,iDAAA;EACA;;IAEE,2BAAA;IACA,qBAAA;IACA,8BAAA;IACA,0BAAA;IACA,sBAAA;IACA,qBAAA;IACA,oBAAA;IACA,kBAAA;EA1DJ;EA6DE,uBAAA;EACA;IACE,6BAAA;IACA,8BAAA;EA3DJ;EA6DE;IACE,8BAAA;EA3DJ;EA6DE;IACE,2BAAA;IACA,sBAAA;IACA,SAAA;EA3DJ;AACF;AA+DA,wDAAA;AACA;EACI;IACE,aAAA;IACA,sBAAA;EA7DJ;EA+DE;IACE,SAAA,EAAA,gBAAA;IACA,mBAAA,EAAA,eAAA;EA7DJ;EA+DE;IACE,QAAA;EA7DJ;AACF;AAgEE,qCAAA;AACA;EACE,UAAA;AA9DJ","sourcesContent":[".memberloginbannertext {\n    position: absolute;\n    left: 3%;\n    top: 5%;\n}\n/**\n* General variables\n*/\n$bdrds: 3px;\n\n$white: #fff;\n$black: #000;\n$gray: #ccc;\n$smoky-black: rgba(#222222, .85);\n\n$ff: 'Montserrat', sans-serif;\n$ff-body: 12px;\n$ff-light: 300;\n$ff-regular: 400;\n$ff-medium: 500;\n\n\n/**\n* General configs\n*/\nbutton {\nbackground-color: transparent;\npadding: 0;\nborder: 0;\noutline: 0;\ncursor: pointer;\n}\n\ninput {\nbackground-color: transparent;\npadding: 0;\nborder: 0;\noutline: 0;\n\n&[type=\"submit\"] {\n    cursor: pointer;\n}\n\n&::placeholder {\n    font-size: .85rem;\n    letter-spacing: .1rem;\n    color: $gray;\n}\n}\n\n/**\n* Bounce to the left side\n*/\n@keyframes bounceLeft {\n0% {\n    transform: translate3d(100%, -50%, 0);\n}\n\n50% {\n    transform: translate3d(-30px, -50%, 0);\n}\n\n100% {\n    transform: translate3d(0, -50%, 0);\n}\n}\n\n/**\n* Bounce to the left side\n*/\n@keyframes bounceRight {\n0% {\n    transform: translate3d(0, -50%, 0);\n}\n\n50% {\n    transform: translate3d(calc(100% + 30px), -50%, 0);\n}\n\n100% {\n    transform: translate3d(100%, -50%, 0);\n}\n}\n\n\n\n/**\n* Show Sign Up form\n*/\n@keyframes showSignUp {\n100% {\n    opacity: 1;\n    visibility: visible;\n    transform: translate3d(0, 0, 0);\n}\n}\n/**\n* Page background\n*/\n.user {\n    position: absolute;\n    top:50%;\n    transform: translate(50%, -50%);\n    background-size: cover;\n\n    &_options-container {\n    position: relative;\n    }\n\n    &_options-text {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    background-color: $smoky-black;\n    border-radius: $bdrds;\n    }\n}\n\n@media (max-width: 1300px) {\n    .user {\n      position: relative;\n      top: auto;\n      left: auto;\n      transform: none;\n      margin: 0 auto;\n      min-height: 40vh;\n    }\n  }\n\n\n\n.user_options-registered,\n.user_options-unregistered {\n    width: 50%;\n    padding: 75px 45px;\n    color: $white;\n    font-weight: $ff-light;\n\n    &_title {\n    margin-bottom: 15px;\n    font-size: 1.66rem;\n    line-height: 1em;\n    }\n\n    &_text {\n    font-size: .83rem;\n    line-height: 1.4em;\n    }\n\n    &_login,\n    &_signup {\n    margin-top: 30px;\n    border: 1px solid $gray;\n    border-radius: $bdrds;\n    padding: 10px 30px;\n    color: $white;\n    text-transform: uppercase;\n    line-height: 1em;\n    letter-spacing: .2rem;\n    transition: background-color .2s ease-in-out, color .2s ease-in-out;\n\n    &:hover {\n        color: $smoky-black;\n        background-color: $gray;\n    }\n    }\n}\n\n/**\n* Login and signup forms\n*/\n.user_options-forms {\n    position: absolute;\n    top: 50%;\n    left: 30px;\n    width: calc(50% - 30px);\n    min-height: 450px;\n    background-color: $white;\n    border-radius: $bdrds;\n    box-shadow: 2px 0 15px rgba($black, .25);\n    overflow: hidden;\n    transform: translate3d(100%, -50%, 0);\n    transition: transform .4s ease-in-out;\n\n    .user_forms-login {\n    transition: opacity .4s ease-in-out, visibility .4s ease-in-out;\n    }\n\n    .forms {\n    &_title {\n        margin-bottom: 45px;\n        font-size: 1.5rem;\n        font-weight: $ff-medium;\n        line-height: 1em;\n        text-transform: uppercase;\n        color: var(--primary_color);\n        letter-spacing: .1rem;\n    }\n\n    &_field {\n        &:not(:last-of-type) {\n        margin-bottom: 20px;\n        }\n    }\n\n    &_field-input {\n        width: 100%;\n        border-bottom: 1px solid $gray;\n        padding: 6px 20px 6px 6px;\n        font-family: $ff;\n        font-size: 1rem;\n        font-weight: $ff-light;\n        color: darken($gray, 30%);\n        letter-spacing: .1rem;\n        transition: border-color .2s ease-in-out;\n\n        &:focus {\n        border-color: darken($gray, 30%);\n        }\n    }\n\n    &_buttons {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        margin-top: 35px;\n\n        &-forgot {\n        font-family: $ff;\n        letter-spacing: .1rem;\n        color: $gray;\n        text-decoration: underline;\n        transition: color .2s ease-in-out;\n\n        &:hover {\n            color: darken($gray, 10%);\n        }\n        }\n\n        &-action {\n        background-color: var(--primary_color);\n        border-radius: $bdrds;\n        padding: 10px 35px;\n        font-size: 1rem;\n        font-family: $ff;\n        font-weight: $ff-light;\n        color: $white;\n        text-transform: uppercase;\n        letter-spacing: .1rem;\n        transition: background-color .2s ease-in-out;\n\n        &:hover {\n            background-color: darken(#0a1e22, 10%);\n        }\n        }\n    }\n    }\n    \n    .user_forms-signup,\n    .user_forms-login {\n    position: absolute;\n    top: 70px;\n    left: 40px;\n    width: calc(100% - 80px);\n    opacity: 0;\n    visibility: hidden;\n    transition: opacity .4s ease-in-out, visibility .4s ease-in-out, transform .5s ease-in-out;\n    }\n\n    .user_forms-signup {\n    transform: translate3d(120px, 0, 0);\n\n    .forms_buttons {\n        justify-content: flex-end;\n    }\n    }\n\n    .user_forms-login {\n    transform: translate3d(0, 0, 0);\n    opacity: 1;\n    visibility: visible;\n    }\n}\n\n/**\n* Triggers\n*/\n.user_options-forms {\n    &.bounceLeft {\n    animation: bounceLeft 1s forwards;\n\n    .user_forms-signup {\n        animation: showSignUp 1s forwards;\n    }\n\n    .user_forms-login {\n        opacity: 0;\n        visibility: hidden;\n        transform: translate3d(-120px, 0, 0);\n    }\n    }\n\n    &.bounceRight {\n    animation: bounceRight 1s forwards;\n    }\n}\n\n.user_registered-login,\n.user_unregistered-signup {\n    margin-top: 30px;\n    border: 1px solid $gray;\n    border-radius: $bdrds;\n    padding: 10px 30px;\n\n    color: $white;\n    text-transform: uppercase;\n    line-height: 1em;\n    letter-spacing: .2rem;\n\n    transition: background-color .2s ease-in-out, color .2s ease-in-out;\n\n    &:hover {\n        color: $smoky-black;\n        background-color: $gray;\n\n    }\n}\n\n/**\n* Responsive 990px\n*/\n@media screen and (max-width: 990px) {\n    .user_options-forms {\n    min-height: 350px;\n\n    .forms_buttons {\n        flex-direction: column;\n\n        &-action {\n        margin-top: 30px;\n        }\n    }\n\n    .user_forms-signup,\n    .user_forms-login {\n        top: 40px;\n    }\n    }\n\n    .user_options-registered,\n    .user_options-unregistered {\n    padding: 50px 45px;\n    }\n}\n\n/* --- 修正 .user 置中：你原本 translate(50%, -50%) 會把內容推到畫面外 --- */\n.user {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); /* ← 這才是水平垂直置中 */\n    max-width: 1100px;                /* 防止超寬 */\n    width: min(95vw, 1100px);\n  }\n  \n  /* --- 讓「雙欄文字 + 浮動表單」在桌機正常 --- */\n  .user_options-container {\n    position: relative;\n  }\n  \n  .user_options-text {\n    display: flex;\n    justify-content: space-between;\n    gap: 0;                /* 與你的浮動表單搭配，避免出現縫隙 */\n  }\n  \n  /* --- 表單面板維持你的動畫邏輯（桌機） --- */\n  .user_options-forms {\n    /* 你原本的定位就好，保留動畫 */\n  }\n  \n  /* ====== RWD：<= 990px 手機／小平板：改直排、不動畫、好閱讀 ====== */\n  @media (max-width: 990px) {\n  \n    /* 1) 登入區塊脫離 banner 絕對定位，回到一般文流 */\n    .user {\n      position: relative !important;\n      top: auto !important;\n      left: auto !important;\n      transform: none !important;\n      width: 100% !important;\n      max-width: 720px;\n      margin: 0 auto;\n      padding: 16px;\n    }\n  \n    /* 2) 左右兩塊文字改成上下直排 */\n    .user_options-text {\n      flex-direction: column;\n      background: rgba(34,34,34,.85);\n      border-radius: 4px;\n    }\n    .user_options-registered,\n    .user_options-unregistered {\n      width: 100% !important;\n      padding: 32px 20px;\n      text-align: center;\n    }\n  \n    /* 3) 浮動的表單改為「一般區塊」，撐滿寬度，禁用動畫 */\n    .user_options-forms {\n      position: static !important;\n      width: 100% !important;\n      min-height: auto !important;\n      box-shadow: none !important;\n      transform: none !important;\n      animation: none !important;\n      margin-top: 16px;\n      border-radius: 4px;\n    }\n    .user_options-forms.bounceLeft,\n    .user_options-forms.bounceRight { animation: none !important; }\n  \n    /* 4) 內部兩個面板用 React 控（你本來就用 state 二選一），這裡統一可見樣式 */\n    .user_options-forms .user_forms-login,\n    .user_options-forms .user_forms-signup {\n      position: static !important;\n      opacity: 1 !important;\n      visibility: visible !important;\n      transform: none !important;\n      width: 100% !important;\n      left: auto !important;\n      top: auto !important;\n      padding: 24px 16px;\n    }\n  \n    /* 5) 表單字級與間距微調，手機更易讀 */\n    .user_options-forms .forms_title {\n      font-size: 1.25rem !important;\n      margin-bottom: 16px !important;\n    }\n    .user_options-forms .forms_field:not(:last-of-type) {\n      margin-bottom: 14px !important;\n    }\n    .user_options-forms .forms_buttons {\n      margin-top: 20px !important;\n      flex-direction: column;\n      gap: 12px;\n    }\n  }\n  \n  \n/* 手機：讓 .user_options-forms 在上面，.user_options-text 在下面 */\n@media (max-width: 990px){\n    .user_options-container{\n      display: flex;\n      flex-direction: column;\n    }\n    .user_options-forms{\n      order: -1;           /* ← 表單排第一（上層） */\n      margin-bottom: 16px; /* 與下方說明區留點距離 */\n    }\n    .user_options-text{\n      order: 0;\n    }\n  }\n  \n  /* 桌機保險一層：確保浮動表單覆蓋在文字之上（維持你原本的上層效果） */\n  .user_options-forms{ \n    z-index: 2;\n  }\n    "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
